import React from 'react';
import { Card, CardSection } from '../primitives';
import { SkeletonText } from './SkeletonText';

interface ISkeletonPanelProps {
    children?: React.ReactNode;
    title?: boolean;
    fullWidth?: boolean;
}

interface ISkeletonSectionProps {
    children?: React.ReactNode;
    title?: boolean;
    subdued?: boolean;
    className?: string;
}

export const SkeletonPanel: React.FC<React.PropsWithChildren<ISkeletonPanelProps>> & {
    Section: React.FC<React.PropsWithChildren<ISkeletonSectionProps>>;
} = ({
    title,
    children,
    fullWidth = false,
}) => {
    return (
        <Card className={`overflow-hidden ${fullWidth ? 'w-full' : ''}`}>
            {title && (
                <h2 className="px-4 pt-5 text-base font-semibold text-foreground sm:px-6">
                    <SkeletonText lines={1} variant="heading" width={120} />
                </h2>
            )}
            {children}
        </Card>
    );
};

SkeletonPanel.Section = ({ subdued = false, className = '', children, title }) => {
    return (
        <CardSection subdued={subdued} className={className}>
            {title && (
                <h3 className="pb-4 text-base font-semibold text-foreground">
                    <SkeletonText lines={1} variant="heading" />
                </h3>
            )}
            {children}
        </CardSection>
    );
};
